import React from 'react';
import cn from 'classnames';
import Link from 'components/UI/Link';
import LazyImage from 'components/UI/LazyImage';
import { useTrans } from 'utils/localisation';

import * as styles from './DefaultReviewCard.module.scss';

const CARDLINK =
  'https://clutch.co/profile/andersen?_gl=1%2A1e4hsnw%2A_ga%2AMzYyODA2Nzc4LjE2Njg2ODUyMjk.%2A_ga_SK8K6HV271%2AMTY3MjMwNjQ1Mi4xMDcuMS4xNjcyMzEwNjA3LjQ5LjAuMA..&sort_by=date_ACS#summary';

export default function DefaultReviewCard({ className }) {
  const t = useTrans(['common', 'reviewCard']);
  return (
    <Link className={cn(styles.card, className)} href={CARDLINK}>
      <div className={styles.iconWrapper}>
        <LazyImage
          className={styles.icon}
          src="https://static.andersenlab.com/andersenlab/new-andersensite/icons/clutch-verified-color.svg"
          alt="Clutch.co"
        />
      </div>
      <div className={styles.right}>
        <div className={styles.titleRow}>
          <div className={styles.title}>{t('reviewCardTitle')}</div>
          <div className={styles.rating}>4.9</div>
        </div>
        <div className={styles.text}>
          {t('reviewCardText')}
          <div className={styles.link}>{t('readMore')}</div>
        </div>
      </div>
    </Link>
  );
}
